import { _firestore } from '../firebase';

const TIME_REGEX = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;

const twelveHourToSeconds = (str) => {
  if (!str || typeof str !== 'string') return null;
  const match = TIME_REGEX.exec(str.trim());
  if (!match) return null;
  let hours = Number(match[1]);
  const minutes = Number(match[2]);
  const ampm = match[3].toUpperCase();
  if (ampm === 'PM' && hours !== 12) hours += 12;
  if (ampm === 'AM' && hours === 12) hours = 0;
  return hours * 3600 + minutes * 60;
};

const isSlotFull = (slot) => {
  const maxOrders = Number(slot.maxOrders);
  const orders = Number(slot.orders) || 0;
  const maxVolume = Number(slot.orderVolume);
  const volume = Number(slot.volume) || 0;
  const type = String(slot.type);
  if (type === '0') {
    return Number.isFinite(maxOrders) && maxOrders > 0 && orders >= maxOrders;
  }
  if (type === '1') {
    return Number.isFinite(maxVolume) && maxVolume > 0 && volume >= maxVolume;
  }
  if (type === '2') {
    const ordersCapped =
      Number.isFinite(maxOrders) && maxOrders > 0 && orders >= maxOrders;
    const volumeCapped =
      Number.isFinite(maxVolume) && maxVolume > 0 && volume >= maxVolume;
    return ordersCapped && volumeCapped;
  }
  return false;
};

const filterDay = async (dayObj, storeId) => {
  try {
    if (!dayObj || !Array.isArray(dayObj.times) || dayObj.times.length === 0) {
      return dayObj;
    }

    const snap = await _firestore
      .collection('OrderThrottlingSlot')
      .where('storeId', '==', storeId)
      .where('date', '==', dayObj.dateString)
      .get();

    if (!snap || snap.empty) return dayObj;

    const fullSlots = [];
    snap.forEach((doc) => {
      const data = doc.data();
      if (isSlotFull(data)) fullSlots.push(data);
    });

    if (fullSlots.length === 0) return dayObj;

    const filteredTimes = dayObj.times.filter((t) => {
      const secs = twelveHourToSeconds(t?.displayForUse);
      if (secs === null) return true;
      return !fullSlots.some(
        (s) => Number(s.startTime) <= secs && Number(s.endTime) >= secs
      );
    });

    return {
      ...dayObj,
      times: filteredTimes,
      timeGroup: { displayTime: filteredTimes.map((t) => t.display) },
      valueGroup: {
        displayTime: filteredTimes.length ? filteredTimes[0].display : '',
      },
    };
  } catch (_err) {
    return dayObj;
  }
};

export const filterThrottledTimeSlots = async (timeSlotDays, storeId) => {
  try {
    if (!Array.isArray(timeSlotDays) || timeSlotDays.length === 0) {
      return timeSlotDays;
    }
    if (!storeId) return timeSlotDays;

    const results = await Promise.all(
      timeSlotDays.map((dayObj) => filterDay(dayObj, storeId))
    );

    return results.filter(
      (d) => d && Array.isArray(d.times) && d.times.length > 0
    );
  } catch (_err) {
    return timeSlotDays;
  }
};

export default filterThrottledTimeSlots;
